import sanitize from 'sanitize-html'
import marked from 'marked'
import { ITag } from '../components/Tags/Tags.types'

// Sanitizing

const allowedTags = sanitize.defaults.allowedTags.concat(['img', 'iframe'])
const allowedAttributes = {
  ...sanitize.defaults.allowedAttributes,
  img: ['src', 'alt', 'title', 'width', 'height'],
  iframe: ['src', 'allowfullscreen', 'alt', 'title', 'width', 'height'],
  a: [...sanitize.defaults.allowedAttributes.a, 'rel'],
}
const allowedSchemes = sanitize.defaults.allowedSchemes.concat(['blob', 'tel'])

export const sanitizeHtml = (html: string) =>
  sanitize(html, {
    allowedTags,
    allowedAttributes,
    allowedSchemes,
  })

// Marked

const renderer = new marked.Renderer()

renderer.link = (href, title, text) => {
  let a = `<a href="${href}"`
  if (title) a += ` title="${title}"`
  if (href?.match(/^https?:\/\//)) a += ` target="_blank" rel="noreferrer noopener nofollow"`
  a += `>${text}</a>`
  return a
}

export const markedWithSanitize = (body: string) => sanitizeHtml(marked(body, { headerIds: false, renderer }))

export const cls = (...classes: (string | false | undefined)[]): string => {
  return classes.filter(Boolean).join(' ')
}

export const tagUrlify = (tag: ITag): string => {
  return tag.toLowerCase().replace('/', '-')
}
